export default __webpack_public_path__ + "static/media/miguel-lopes-21.4a7ea7b8.jpg";